import React from 'react'
import { Tab, Tabs } from '@mui/material'
import EndUser from './end-user/Page'
import Dealer from './dealer/Page'
import { Routes, Route, NavLink, useLocation } from 'react-router-dom'

const tabs = [
  { label: 'Mystery Shopper', to: 'dealer/mystery-shopper' },
  { label: 'Apple Lucky Draw', to: 'end-user/apple-products-lucky-draw' },
  { label: 'Lucky Draw', to: 'dealer/lucky-draw' },
  { label: 'Win a GWM', to: 'end-user/scratch-card-redemption' },
]

const Page = () => {
  // To retrieve current url
  const location = useLocation()

  // Get and set the active tab based on current url
  const tabValue =
    tabs.find(({ to }) => location.pathname.startsWith(`/admin/promotions/${to}`))?.to ?? false

  return (
    <div>
      {/* Tab Header */}
      <Tabs value={tabValue}>
        {tabs.map(({ label, to }) => (
          <Tab key={to} label={label} component={NavLink} to={to} value={to} />
        ))}
      </Tabs>
      {/* Tab/Route Content */}
      <Routes>
        <Route path='/dealer/*' element={<Dealer />} />
        <Route path='/end-user/*' element={<EndUser />} />
      </Routes>
    </div>
  )
}

export default Page
